// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__CB","cls2":"Header-cls2_E5v Header-cls1__CB","small":"Header-small_D_M"};